<template>
  <div class="container">
      <Layout>
          <Row class="hint-img">
              <img src="../assets/image/error.png"/>
          </Row>
          <Row class="hint">
              <p>{{text}}</p>
              <!--        <p>Please do not buy.</p>-->
          </Row>
          <Row>
              <Button class="btn" long type="primary" @click="handleClick()">
                  {{$t('message.A_fake_counterfeits')}}
              </Button>
          </Row>
      </Layout>
  </div>
</template>

<script>
  export default {
      name: "A_error",
      data() {
          return {
              text: ''
          }
      },
      created() {
          // this.text = this.$route.params.text;
          this.getText();
      },
      methods: {
          handleClick() {
              this.$router.push({name: 'Inform'});
          },
          getText() {
              let _me = this;
              _me.text = _me.$route.params.text;
              if (_me.text == undefined) {
                  let list = sessionStorage.getItem("text");
                  _me.text = JSON.parse(list);
              } else {
                  sessionStorage.setItem("text", JSON.stringify(_me.text));
              }
          }
      }
  }
</script>

<style scoped>

</style>
